import _ from 'lodash'
import Vue from 'vue'
import apiCall from './call'

const invites = {

  state: {
    invite: {
      userId: null,
      firstName: null,
      lastName: null,
      email: null,
      companyName: null,
      companyId: null
    },
    errors: {},
    invitePending: false,
    searchingUsers: false,
    searchingCompanies: false,
    existingInvites: []
  },

  mutations: {

    setInviteListing (state, invites) {
      state.existingInvites = invites
    },

    setInvite (state, invite) {
      state.invite = invite
    },

    setInviteUser (state, userList) {
      if (_.isArray(userList) && userList.length) {
        Vue.set(state, 'invite', {
          userId: userList[0].id,
          email: userList[0].email,
          firstName: userList[0].name.first_name,
          lastName: userList[0].name.last_name,
          companyName: userList[0].company.name,
          companyId: userList[0].company.id
        })
      }

      state.searchingUsers = false
      state.invitePending = true
    }
  },

  actions: {
    clearStore ({ commit }) {
      commit('reset')
    },

    getInviteList ({ commit }, accountId) {
      apiCall({
        url: 'account_invites',
        method: 'GET',
        qs: {
          account_id: accountId
        }
      }).then(response => {
        commit('setInviteListing', response.data)
      }).catch(error => {
        console.error(error)
      })
    },

    getInvite ({ commit }, inviteId) {
      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites/' + inviteId,
          method: 'GET'
        }).then(response => {
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },

    extendInvite ({ commit }, inviteId) {
      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites/actions',
          method: 'post',
          data: {
            action: 'extend',
            selectedIds: [inviteId]
          }
        }).then(response => {
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },

    revokeInvite ({ commit }, inviteId) {
      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites/actions',
          method: 'post',
          data: {
            action: 'revoke',
            selectedIds: [inviteId]
          }
        }).then(response => {
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },

    makeInvitePermanent ({ commit }, inviteId) {
      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites/actions',
          method: 'post',
          data: {
            action: 'issue_permanently',
            selectedIds: [inviteId]
          }
        }).then(response => {
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    },

    inviteQuery ({ commit }, queryString) {
      return apiCall({
        url: 'account_invites/inviting',
        method: 'GET',
        qs: queryString
      })
    },

    createInvite ({ commit }, invite) {
      let newInvite = {}

      const formFields = {
        userId: 'user_id',
        accountId: 'account_id',
        firstName: 'first_name',
        lastName: 'last_name',
        email: 'email',
        companyName: 'company',
        companyId: 'company_id',
        role: 'role'
      }

      _.forEach(formFields, function (value, key) {
        if (_.has(invite, key) && !_.isNull(invite[key])) {
          newInvite[value] = invite[key]
        }
      })

      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites',
          method: 'POST',
          data: newInvite
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    notifyInvite ({ commit }, invite) {
      let theInvite = {}

      const formFields = {
        inviteId: 'invite_id'
      }

      _.forEach(formFields, function (value, key) {
        if (_.has(invite, key) && !_.isNull(invite[key])) {
          theInvite[value] = invite[key]
        }
      })

      return new Promise((resolve, reject) => {
        apiCall({
          url: 'account_invites/send',
          method: 'POST',
          data: theInvite
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },

  getters: {
    isSearchingUsers: state => {
      return state.searchingUsers
    },
    isSearchingCompanies: state => {
      return state.searchingCompanies
    },
    inviteList: state => {
      return state.existingInvites
    },
    isInvitePending: state => {
      return state.invitePending
    },
    pendingInvite: state => {
      return state.invite
    },
    inviteErrors: state => {
      if (_.isEmpty(state.errors)) {
        return null
      }
      return state.errors
    }
  }

}

export default invites



// WEBPACK FOOTER //
// ./src/store/modules/invites.js